import { DEBUG } from "../support-extra/js/debug";
import { SERVER_URL } from "../support-extra/js/server";

const SERVER = SERVER_URL;

export let post = async (funct, body) => {
  let endpoint = SERVER;
  endpoint = endpoint + funct;
  try {
    const response = await fetch(endpoint, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    const textData = await response.text();
    let data;
    try {
      data = JSON.parse(textData);
    } catch (parseError) {
      if (DEBUG) {
        console.error(parseError.message, textData);
      } else {
        console.error(parseError.message);
      }
      throw parseError;
    }
    if (DEBUG) {
      const debug = {
        endpoint,
        body,
        responseText: textData,
        responseJSON: data,
      };
      console.log(debug);
    }
    return data;
  } catch (e) {
    if (DEBUG) {
      const debug = {
        endpoint,
        body,
      };
      console.log(debug);
    }
    console.error(e, funct);
  }
};

export let postgz = async (funct, body) => {
  let endpoint = SERVER;
  endpoint = endpoint + funct;
  try {
    const response = await fetch(endpoint, {
      method: "post",
      headers: {
        Accept: "application/gzip",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    const arrayBuffer = await response.arrayBuffer();
    const ds = new DecompressionStream("gzip");
    const writer = ds.writable.getWriter();
    writer.write(arrayBuffer);
    writer.close();
    const textData = await new Response(ds.readable).text();
    let data;
    try {
      data = JSON.parse(textData);
    } catch (parseError) {
      if (DEBUG) {
        console.error(parseError.message, textData);
      } else {
        console.error(parseError.message);
      }
      throw parseError;
    }
    if (DEBUG) {
      const debug = {
        endpoint,
        body,
        responseText: textData,
        responseJSON: data,
      };
      console.log(debug);
    }
    return data;
  } catch (e) {
    if (DEBUG) {
      const debug = {
        endpoint,
        body,
      };
      console.log(debug);
    }
    console.error(e, funct);
  }
};

// Con { abrirEnPestana: true }, el fichero recibido (p.ej. un PDF) se abre
// en una pestaña nueva en vez de descargarse. La pestaña se abre al
// principio, antes del fetch, para que siga dentro del gesto del usuario
// (click) y el navegador no la bloquee como popup.
export let download = async (funct, body, { abrirEnPestana = false } = {}) => {
  let endpoint = SERVER;
  endpoint = endpoint + funct;
  const pestana = abrirEnPestana ? window.open("", "_blank") : null;
  try {
    const response = await fetch(endpoint, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    const contentTypeH = response.headers.get("Content-Type");
    const tokens = contentTypeH.split(";");
    const contentType = tokens[0].split(":")[0].trim();

    if (contentType === "text/html") {
      // JSON received
      if (pestana) pestana.close();

      const textData = await response.text();
      let data;
      try {
        data = JSON.parse(textData);
      } catch (parseError) {
        if (DEBUG) {
          console.error(parseError.message, textData);
        } else {
          console.error(parseError.message);
        }
        throw parseError;
      }
      if (DEBUG) {
        const debug = {
          endpoint,
          body,
          responseText: textData,
          responseJSON: data,
        };
        console.log(debug);
      }
      return data;
    } else {
      // Blob received

      const blob = await response.blob();

      const contentDisposition = response.headers.get("Content-Disposition");
      let filename = `datos_${new Date().toISOString().split("T")[0]}.csv`; // fallback
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }

      const url = window.URL.createObjectURL(blob);
      if (pestana) {
        pestana.location.href = url;
        // La pestaña necesita la URL mientras carga el fichero.
        setTimeout(() => window.URL.revokeObjectURL(url), 60000);
      } else {
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }

      const resp = { error: "" };
      if (DEBUG) {
        const debug = {
          endpoint,
          body,
          responseText: JSON.stringify(resp),
          responseJSON: resp,
        };
        console.log(debug);
      }
      return resp;
    }
  } catch (e) {
    if (pestana) pestana.close();
    if (DEBUG) {
      const debug = {
        endpoint,
        body,
      };
      console.log(debug);
    }
    console.error(e, funct);
  }
};
